<!-- Título do stepper -->
<div class="mt-20">
  <h1 class="text-charcoal-800 text-heading-md font-bold m-0 mb-2">Modo edição</h1>
  <p class="text-charcoal-800 text-body-lg font-regular m-0">Edição de parâmetros de localidade</p>
</div>

<!-- Navegação das etapas -->
  <div class="mt-8" *ngIf="configuracaoAtual">
    <div class="side-options-view">
      <div class="side-options-container flex flex-col gap-4">
        <div class="side-options-container-line"></div>

        <!-- Iteração pelas seções -->
        <ng-container *ngFor="let secao of configuracaoAtual.secoes">
          
          <!-- Cabeçalho da seção -->
          <div class="side-option-image-container flex gap-2 items-center cursor-pointer">
            <div *ngIf="secaoDesabilitada(secao.id)" class="side-options-disabled-line"></div>

            <!-- Ícone da seção -->
            <img
              *ngIf="secaoDesabilitada(secao.id)"
              [src]="secao.icone.desabilitado"
              [alt]="secao.titulo + '-desabilitado'"
            >

            <img
              *ngIf="!secaoDesabilitada(secao.id) && secaoConcluida(secao.id)"
              [src]="secao.icone.preenchido"
              [alt]="secao.titulo + '-preenchido'"
            >

            <img
              *ngIf="!secaoDesabilitada(secao.id) && !secaoConcluida(secao.id)"
              [src]="secao.icone.padrao"
              [alt]="secao.titulo + '-padrao'"
            >

            <span
              class="text-charcoal-800 text-body-xlg font-regular"
              [ngClass]="{'disabled-text': secaoDesabilitada(secao.id)}"
            >
              {{ secao.titulo }}
            </span>
          </div>

          <!-- Etapas da seção -->
          <ng-container *ngFor="let etapa of secao.etapas">
            <div
              class="side-options flex gap-2 items-center ms-3"
              [ngClass]="{'cursor-pointer': !etapa.desabilitado, 'cursor-not-allowed': etapa.desabilitado}"
              (click)="navegarParaEtapa(etapa.rota, etapa.id, etapa.desabilitado)"
            >
              <div *ngIf="etapa.desabilitado" class="side-options-disabled-line"></div>

              <!-- Círculo numerado da etapa -->
              <div
                class="w-5 h-5 border-2 rounded-xl flex items-center justify-center"
                [ngClass]="{
                  'border-crayola-400 bg-gray-50': !etapa.desabilitado && !etapaConcluida(etapa.id),
                  'border-0 bg-crayola-400': etapaConcluida(etapa.id) && !etapa.desabilitado,
                  'disabled-circle': etapa.desabilitado
                }"
              >
                <span
                  class="text-body-lg font-regular"
                  [ngClass]="{
                    'text-crayola-400': !etapa.desabilitado && !etapaConcluida(etapa.id),
                    'text-gray-50-important': etapaConcluida(etapa.id) && !etapa.desabilitado,
                    'text-gray-300': etapa.desabilitado
                  }"
                >
                  {{ etapa.numeroSecao }}
                </span>
              </div>

              <!-- Título da etapa -->
              <span
                class="text-charcoal-800 text-body-lg font-regular"
                [ngClass]="{
                  'text-crayola-400 underline': etapaAtiva(etapa.id) && !etapa.desabilitado,
                  'disabled-text': etapa.desabilitado
                }"
              >
                {{ etapa.titulo }}
              </span>
            </div>
          </ng-container>

        </ng-container>
      </div>
    </div>

    <!-- Ações do Stepper -->
    <div class="flex justify-between mt-10">
      <div 
        *ngIf="podeVoltarEtapa()" 
        (click)="etapaAnterior()" 
        class="flex gap-2 items-center cursor-pointer"
      >
        <img src="assets/icons/arrow-left.svg" alt="arrow-left" class="icon w-4 h-4">
        <span class="text-charcoal-800 text-body-lg font-regular">Anterior</span>
      </div>

      <div (click)="proximaEtapa()" class="flex gap-2 items-center cursor-pointer">
        <span class="text-charcoal-800 text-body-lg font-regular">Próximo</span>
        <img src="assets/icons/arrow-right.svg" alt="arrow-right" class="icon w-4 h-4">
      </div>
    </div>
  </div>

<!-- Ações do Stepper -->
<div class="actions-container flex flex-col gap-4 mt-8">
  <div (click)="gerarResultado()" class="action flex gap-2 items-center cursor-pointer">
    <img src="assets/icons/play.svg" id="play-icon" alt="play" class="icon w-4 h-4">
    <span class="text-red-500 text-body-lg font-regular">Gerar novo resultado</span>
  </div>
  <div (click)="voltarAoInicio()" class="action flex gap-2 items-center cursor-pointer">
    <img src="assets/icons/house.svg" id="home-icon" alt="home" class="icon w-4 h-4">
    <span class="text-charcoal-800 text-body-lg font-regular">Voltar ao início</span>
  </div>
</div>